module.exports = __webpack_public_path__ + "img/malna-24.4204f07d.webp";